// Port of api/fuel/app/classes/model/config.php
import Model from 'offline/stream/model/base'
import DB from 'offline/db'

// Per-process cache of parsed configs by user_id. Config.user is called
// thousands of times per insights run (e.g. shelf.cumulative iterates
// designers × games and calls formatFromConfig per game), and each call
// otherwise hits DB.query + JSON.parse + deepMerge. The result is
// effectively constant within a single Insights.generate() call, so we
// memoize. Call Config.invalidate() if you're mutating config in-process.
var _userCache = {}

var CONFIG_TEMPLATE = {
	sync: { plays: { incomplete: false } },
	ratings: { layout: 0 },
	plays: { layout: 0, usernames: [] },
	gameplays: { layout: 0 },
	other: { currency: 'USD', exchange: 1 },
	insights: {
		hindex: { expansions: false, exclude: [] },
		size: { expansions: false },
		heatmap: { start: 'sunday' },
		records: { start: 0 }
	},
	filter: { expansions: 1 },
	lists: { unplayed: { type: 'shame', games: [], trade: true, rated: true } },
	collection: {
		comments: false,
		layout: 0,
		nest: true,
		status: 0,
		contains: true,
		inventory: { location: { public: false } }
	}
}

function deepMerge(base, override) {
	var result = {}
	var keys = Object.keys(base)
	for (var i = 0; i < keys.length; i++) {
		var k = keys[i]
		if (override && override[k] !== undefined) {
			if (base[k] !== null && typeof base[k] === 'object' && !Array.isArray(base[k])) {
				result[k] = deepMerge(base[k], override[k])
			} else {
				result[k] = override[k]
			}
		} else {
			result[k] = (typeof base[k] === 'object' && base[k] !== null && !Array.isArray(base[k])) ? deepMerge(base[k], {}) : base[k]
		}
	}
	return result
}

export default Model.extend({
	table: 'config',
	prefix: '',
	key: 'config_id',
	fields: {
		config_id: Model.SCHEMA_NUMBER,
		user_id: Model.SCHEMA_NUMBER,
		group_id: Model.SCHEMA_NUMBER,
		buddies_id: Model.SCHEMA_NUMBER,
		session_id: Model.SCHEMA_TEXT,
		config_data: Model.SCHEMA_JSON
	},
	methods: {
		to_array: function() {
			return this.get_data()
		}
	},
	statics: {
		user: function(id) {
			if (!id) return deepMerge(CONFIG_TEMPLATE, {})
			var cached = _userCache[id]
			if (cached !== undefined) return cached
			var rows = DB.query('SELECT config_data FROM config WHERE user_id = ?', [id])
			var data = {}
			if (rows.length && rows[0].config_data) {
				try { data = JSON.parse(rows[0].config_data) } catch (e) { data = {} }
			}
			var merged = deepMerge(CONFIG_TEMPLATE, data)
			_userCache[id] = merged
			return merged
		},
		public: function(userId) {
			var config = this.user(userId)
			return {
				collection: config.collection || {},
				other: { currency: config.other ? config.other.currency : 'USD' }
			}
		},
		// Clear the per-user config cache. Call this when a user's config
		// changes within the same JS process (e.g. on snapshot reimport).
		invalidate: function(id) {
			if (id) delete _userCache[id]
			else _userCache = {}
		}
	}
})
